import {
  mdiCartOutline,
  mdiWeb,
  mdiInformationOutline,
  mdiChartLine,
  mdiHeadset,
  mdiFlaskOutline,
  mdiShapeOutline,
  mdiClipboardCheckOutline,
  mdiFeatureSearchOutline,
  mdiCalendarTextOutline,
  mdiTagMultipleOutline,
  mdiRobotOutline,
  mdiCube,
  mdiCubeOutline,
  mdiAccountMultiple,
  mdiBriefcaseOutline,
  mdiAccountPlus,
  mdiFormatListBulletedType,
} from '@mdi/js';
import {
  ROLE_PATENT_SPECIALIST,
  ROLE_LOGISTIC_MANGER,
  ROLE_LOGISTIC_MANGER_READ,
  ROLE_RECOMMENDED_PRODUCTS,
  ROLE_STAFF,
  ROLE_WELLNESS_STIMULATION,
  ROLE_VAPING,
  ROLE_ADMIN,
  ROLE_PROMPTS_MANAGER,
} from 'App/constants/Roles';
import {
  CAT_PRODUCTS,
  CAT_PRODUCT_ORDERS,
  CAT_CUSTOMERS,
  CAT_COURIER_DELIVERY_SERVICES,
  CAT_PROJECTS,
  CAT_AGENTS,
  CAT_RECOMMENDED_PRODUCTS,
  CAT_BRANDS,
  CAT_PATENT_RESEARCH,
  CAT_COMPANIES,
  CAT_STANDING_REPORTS,
  CAT_FILES,
  CAT_SAMPLES,
  CAT_COMPONENTS,
  CAT_CONTACTS,
  CAT_TRADEMARKS,
  CAT_NEWS,
  CAT_EVENTS,
  CAT_USERS,
  CAT_RESEARCHES,
  CAT_EVENT_TYPES,
  CAT_EVENT_THEMES,
  CAT_INFORMATION_SOURCES,
  CAT_CONSUMABLE_VARIATIONS,
  CAT_TYPES,
  CAT_SAMPLE_CONDITIONS,
  CAT_FEATURES,
  CAT_AI_NEWS_PROMPTS,
  CAT_WEBSITE_DEALS,
  CAT_INFO_REQUESTS,
  CAT_ANALYZE_REQUESTS,
  CAT_ATTENDING_REQUESTS,
  CAT_WEBSITES,
  CAT_WEBSITE_SERVICES,
  CAT_STATUSES,
  CAT_ACTIVITY_SPHERES,
  CAT_INGREDIENT_CATEGORIES,
  FEATURE_GROUP_INGREDIENT_CATEGORY_ID,
  CAT_SOCIAL_MEDIA_SCRAPER_CORE_ACCOUNTS,
} from 'App/constants/categories';
import {
  SUB_PRODUCTS_VAPING_DEV,
  TEARDOWN_REPORTS,
  PRODUCTS_SUBCATEGORIES,
  PRODUCTS_SUBCATEGORIES_MAP,
  SUB_ORDERS_SA,
  SUB_ORDERS_WS,
  SUB_WEBSITE_DEALS,
  SUB_WEBSITE_DEALS_DEALS,
  SUB_INFO_REQUESTS,
  SUB_ANALYZE_REQUESTS,
  SUB_ATTENDING_REQUESTS,
  SUB_PRODUCT_ORDERS,
  SUB_CUSTOMERS,
  SUB_COURIER_DELIVERY_SERVICES,
  SUB_PROJECTS,
  SUB_AGENTS,
  SUB_WEBSITES,
  SUB_WEBSITE_SERVICES,
  SUB_STATUSES,
  SUB_CORE_ACCOUNTS,
  SUB_WIMS_REGISTRATIONS,
} from 'App/constants/subcategories';

export const CMS_TAB_PRODS_DRAFT = 'products_draft';
export const CMS_TAB_PRODS = CAT_PRODUCTS;
export const CMS_TAB_CRM = 'crm';
export const CMS_TAB_PRODUCT_ORDERS = CAT_PRODUCT_ORDERS;
export const CMS_TAB_CUSTOMERS = CAT_CUSTOMERS;
export const CMS_TAB_COURIER_DELIVERY_SERVICES = CAT_COURIER_DELIVERY_SERVICES;
export const CMS_TAB_PROJECTS = CAT_PROJECTS;
export const CMS_TAB_AGENTS = CAT_AGENTS;
export const CMS_TAB_RECOMMENDED_PRODUCTS = CAT_RECOMMENDED_PRODUCTS;
export const CMS_TAB_BRANDS = CAT_BRANDS;
export const CMS_TAB_PATENT_RESEARCH = 'patent_research';
export const CMS_TAB_COMPANIES = CAT_COMPANIES;
export const CMS_TAB_COMPANIES_DRAFT = 'companies_draft';
export const CMS_TAB_STANDING_REPORTS = CAT_STANDING_REPORTS;
export const CMS_TAB_FILES = CAT_FILES;
export const CMS_TAB_SAMPLES = CAT_SAMPLES;
export const CMS_TAB_REF_DATA = 'ref_data';
export const CMS_TAB_STATS = 'stats_reports';
export const CMS_TAB_COMPONENTS = CAT_COMPONENTS;
export const CMS_TAB_CONTACTS = CAT_CONTACTS;
export const CMS_TAB_TRADEMARKS = CAT_TRADEMARKS;
export const CMS_TAB_NEWS = CAT_NEWS;
export const CMS_TAB_EVENTS = CAT_EVENTS;
export const CMS_TAB_USERS = CAT_USERS;
export const CMS_TAB_RESEARCHES = CAT_RESEARCHES;
export const CMS_TAB_EVENT_TYPES = CAT_EVENTS;
export const CMS_TAB_EVENT_THEMES = CAT_EVENT_THEMES;
export const CMS_TAB_INFORMATION_SOURCES = CAT_INFORMATION_SOURCES;
export const CMS_SUB_TAB_COMPONENTS_DRAFT = 'sub_components_draft';
export const CMS_SUB_TAB_COMPONENTS = 'sub_components';
export const CMS_SUB_TAB_EVENTS_THEMES = 'sub_event_themes';

export const CMS_TABS = [
  {
    id: CMS_TAB_PRODS_DRAFT,
    cat: null,
    title: 'Products Draft',
    filter: { draft: true },
    defSubTab: SUB_PRODUCTS_VAPING_DEV,
    editCat: CAT_PRODUCTS,
  },
  {
    id: CMS_TAB_PRODS,
    cat: null,
    title: 'Products',
    filter: { draft: false },
    defSubTab: SUB_PRODUCTS_VAPING_DEV,
    editCat: CAT_PRODUCTS,
  },
  {
    id: CMS_TAB_RECOMMENDED_PRODUCTS,
    cat: CAT_RECOMMENDED_PRODUCTS,
    title: 'Recommended Products',
    editCat: CAT_RECOMMENDED_PRODUCTS,
    requiredRoles: [ROLE_RECOMMENDED_PRODUCTS, ROLE_STAFF],
  },
  {
    id: CMS_TAB_CRM,
    cat: null,
    defSubTab: SUB_ORDERS_SA,
    title: 'CRM',
    requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
  },
  { id: CMS_TAB_BRANDS, cat: CAT_BRANDS, title: 'Brands' },
  {
    id: CMS_TAB_PATENT_RESEARCH,
    cat: CAT_PATENT_RESEARCH,
    title: 'Patent research',
    requiredRoles: [ROLE_PATENT_SPECIALIST],
  },
  {
    id: CMS_TAB_COMPANIES_DRAFT,
    cat: CAT_COMPANIES,
    filter: { draft: true },
    title: 'Companies Draft',
  },
  // { id: CMS_TAB_COMPANIES, cat: CAT_COMPANIES, title: 'Companies' },
  {
    id: CMS_TAB_STANDING_REPORTS,
    cat: CAT_STANDING_REPORTS,
    title: 'Standing Reports',
  },
  { id: CMS_TAB_RESEARCHES, cat: CAT_RESEARCHES, title: 'Research' },
  { id: CMS_TAB_FILES, cat: CAT_FILES, title: 'Files' },
  { id: CMS_TAB_SAMPLES, cat: CAT_SAMPLES, title: 'Samples', hidden: true },
  { id: CMS_TAB_NEWS, cat: CAT_NEWS, title: 'News' },
  { id: CMS_TAB_EVENTS, cat: CAT_EVENTS, title: 'Events', defSubTab: CMS_TAB_EVENT_THEMES },
  {
    id: CMS_TAB_REF_DATA,
    cat: null,
    title: 'Reference Data',
    defSubTab: CAT_CONSUMABLE_VARIATIONS,
  },
  {
    id: CMS_TAB_STATS,
    cat: null,
    title: 'Statistics reports',
    hideActions: true,
  },
  {
    id: CMS_TAB_COMPONENTS,
    cat: null,
    title: 'Components',
    defSubTab: CMS_SUB_TAB_COMPONENTS_DRAFT,
    editCat: CAT_COMPONENTS,
  },
  { id: CMS_TAB_CONTACTS, cat: CAT_CONTACTS, title: 'Contacts' },
  { id: CMS_TAB_TRADEMARKS, cat: CAT_TRADEMARKS, title: 'Trademarks' },
  {
    id: null,
    cat: null,
    title: 'Samples',
    children: [
      { id: CMS_TAB_SAMPLES, cat: CAT_SAMPLES, title: 'Samples' },
      {
        id: null,
        cat: null,
        title: 'External Samples',
        isExternal: true,
        href: 'https://storage.vape.museum/',
      },
    ],
  },
  { id: CMS_TAB_USERS, cat: CAT_USERS, title: 'Users' },
  {
    id: null,
    cat: null,
    title: 'Apps & Services',
    children: [
      {
        id: CMS_TAB_INFORMATION_SOURCES,
        cat: CAT_INFORMATION_SOURCES,
        title: 'Products Information Sources',
        isExternal: false,
      },
      {
        id: 'social-media-scraper',
        cat: null,
        title: 'Social media scraper',
        isExternal: false,
        href: 'social-media-scraper',
      },
      {
        id: null,
        cat: null,
        title: 'Social media scraper panel',
        isExternal: true,
        href: 'https://sm-panel.winglegroup.com',
      },
      {
        id: 'newsletter-emails',
        cat: null,
        title: 'Newsletter emails',
        isExternal: false,
        href: 'newsletter-emails',
      },
      {
        id: null,
        cat: null,
        title: 'Visualizer (Relations graph)',
        isExternal: true,
        href: 'https://visualizer.winglegroup.com/',
      },
      {
        id: null,
        cat: null,
        title: 'Research app',
        isExternal: true,
        href: 'https://scholar-app.winglegroup.com',
      },
      {
        id: null,
        cat: null,
        title: 'News app',
        isExternal: true,
        href: 'https://news-app.winglegroup.com',
      },
      {
        id: null,
        cat: null,
        title: 'Patents app',
        isExternal: true,
        href: 'https://patent-app.winglegroup.com',
      },
      {
        id: null,
        cat: null,
        title: 'Trademarks app',
        isExternal: true,
        href: 'https://trademark-app.winglegroup.com/',
      },
      {
        id: null,
        cat: null,
        title: 'Wayback Machine',
        isExternal: true,
        href: 'https://wayback_machine.winglegroup.com/',
      },
      {
        id: null,
        cat: null,
        title: 'Image extractor',
        isExternal: true,
        href: 'https://images-extractor.winglegroup.com/docs',
      },
      {
        id: null,
        cat: null,
        title: 'Search by image',
        isExternal: true,
        href: 'https://image-based-product-search.winglegroup.com/doc',
      },
      {
        id: null,
        cat: null,
        title: 'Text-recognition',
        isExternal: true,
        href: 'https://text-recognition.winglegroup.com/doc',
      },
    ],
  },
];

const productSubTabs = (commonId, title, draft) => {
  return PRODUCTS_SUBCATEGORIES.map((cat) => {
    const { id, title, requiredRoles, customIcon } = PRODUCTS_SUBCATEGORIES_MAP[cat];
    return {
      id: cat,
      cat: CAT_PRODUCTS,
      filter: { draft, 'category.id': id },
      title,
      // Teardown reports листает те же продукты Smoking Alternatives (category.id = SA), поэтому и
      // роли те же. В PRODUCTS_SUBCATEGORIES_MAP их задавать нельзя: ту же карту перебирает
      // buildSubcategoryRestrictions, и teardown-reports стал бы валидным :subcategory в роутах.
      requiredRoles: cat === TEARDOWN_REPORTS ? [ROLE_VAPING] : requiredRoles,
      categoryId: id,
      customIcon,
    };
  });
};

export const CMS_SUB_TABS = {
  [CMS_TAB_REF_DATA]: [
    {
      id: CAT_CONSUMABLE_VARIATIONS,
      cat: CAT_CONSUMABLE_VARIATIONS,
      title: 'Consumable Variations',
      icon: mdiFlaskOutline,
    },
    { id: CAT_TYPES, cat: CAT_TYPES, title: 'Product Types', icon: mdiShapeOutline },
    {
      id: CAT_SAMPLE_CONDITIONS,
      cat: CAT_SAMPLE_CONDITIONS,
      title: 'Samples Conditions',
      icon: mdiClipboardCheckOutline,
    },
    {
      id: CAT_FEATURES,
      cat: CAT_FEATURES,
      title: 'Features',
      icon: mdiFeatureSearchOutline,
    },
    {
      id: CAT_INGREDIENT_CATEGORIES,
      cat: CAT_INGREDIENT_CATEGORIES,
      title: 'Ingredient category',
      icon: mdiFormatListBulletedType,
      filter: { 'parent.id': FEATURE_GROUP_INGREDIENT_CATEGORY_ID },
    },
    {
      id: CAT_ACTIVITY_SPHERES,
      cat: CAT_ACTIVITY_SPHERES,
      title: 'Spheres of activity',
      icon: mdiBriefcaseOutline,
    },
    {
      id: CAT_EVENT_TYPES,
      cat: CAT_EVENT_TYPES,
      title: 'Event Types',
      icon: mdiCalendarTextOutline,
    },
    {
      id: CAT_EVENT_THEMES,
      cat: CAT_EVENT_THEMES,
      title: 'Event Themes',
      icon: mdiTagMultipleOutline,
    },
    {
      id: CAT_AI_NEWS_PROMPTS,
      cat: CAT_AI_NEWS_PROMPTS,
      title: 'Prompts',
      icon: mdiRobotOutline,
      requiredRoles: [ROLE_ADMIN, ROLE_PROMPTS_MANAGER],
    },
    {
      id: SUB_CORE_ACCOUNTS,
      cat: CAT_SOCIAL_MEDIA_SCRAPER_CORE_ACCOUNTS,
      title: 'Core accounts',
      icon: mdiAccountMultiple,
    },
  ],
  [CMS_TAB_CRM]: [
    {
      id: SUB_ORDERS_SA,
      cat: CAT_PRODUCT_ORDERS,
      title: 'Orders SA',
      icon: mdiCartOutline,
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
      categoryRole: ROLE_VAPING,
      hasSubTabs: true,
    },
    {
      id: SUB_ORDERS_WS,
      cat: CAT_PRODUCT_ORDERS,
      title: 'Orders WS',
      icon: mdiCartOutline,
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
      categoryRole: ROLE_WELLNESS_STIMULATION,
      hasSubTabs: true,
    },
    {
      id: SUB_WEBSITE_DEALS,
      cat: CAT_WEBSITE_DEALS,
      title: 'Website deals',
      icon: mdiWeb,
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
      hasSubTabs: true,
    },
    {
      id: SUB_INFO_REQUESTS,
      cat: CAT_INFO_REQUESTS,
      title: 'Info Requests',
      icon: mdiInformationOutline,
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
    {
      id: SUB_ANALYZE_REQUESTS,
      cat: CAT_ANALYZE_REQUESTS,
      title: 'Analyze requests',
      icon: mdiChartLine,
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
    {
      id: SUB_ATTENDING_REQUESTS,
      cat: CAT_ATTENDING_REQUESTS,
      title: 'Attending requests',
      icon: mdiHeadset,
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
    {
      id: SUB_WIMS_REGISTRATIONS,
      cat: CAT_CUSTOMERS,
      title: 'WIMS Registration',
      icon: mdiAccountPlus,
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
      separated: true,
    },
  ],
  [CMS_TAB_COMPONENTS]: [
    {
      id: CMS_SUB_TAB_COMPONENTS_DRAFT,
      cat: CAT_COMPONENTS,
      title: 'Components Draft',
      icon: mdiCubeOutline,
      filter: { draft: true },
    },
    {
      id: CMS_SUB_TAB_COMPONENTS,
      cat: CAT_COMPONENTS,
      title: 'Components',
      icon: mdiCube,
      filter: { draft: false },
    },
  ],
  [CMS_TAB_PRODS_DRAFT]: productSubTabs(null, 'All Drafts', true),
  [CMS_TAB_PRODS]: productSubTabs(null, 'All Products', false),
  [SUB_ORDERS_SA + '_nested']: [
    {
      id: SUB_PRODUCT_ORDERS,
      cat: CAT_PRODUCT_ORDERS,
      title: 'Orders',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
      categoryRole: ROLE_VAPING,
    },
    {
      id: SUB_COURIER_DELIVERY_SERVICES,
      cat: CAT_COURIER_DELIVERY_SERVICES,
      title: 'Delivery services',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
    {
      id: SUB_PROJECTS,
      cat: CAT_PROJECTS,
      title: 'Projects',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
    {
      id: SUB_AGENTS,
      cat: CAT_AGENTS,
      title: 'Agents',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
  ],
  [SUB_ORDERS_WS + '_nested']: [
    {
      id: SUB_PRODUCT_ORDERS,
      cat: CAT_PRODUCT_ORDERS,
      title: 'Orders',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
      categoryRole: ROLE_WELLNESS_STIMULATION,
    },
    {
      id: SUB_COURIER_DELIVERY_SERVICES,
      cat: CAT_COURIER_DELIVERY_SERVICES,
      title: 'Delivery services',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
    {
      id: SUB_PROJECTS,
      cat: CAT_PROJECTS,
      title: 'Projects',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
    {
      id: SUB_AGENTS,
      cat: CAT_AGENTS,
      title: 'Agents',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
  ],
  website_deals_nested: [
    {
      id: SUB_WEBSITE_DEALS_DEALS,
      cat: CAT_WEBSITE_DEALS,
      title: 'Deals',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
    {
      id: SUB_WEBSITES,
      cat: CAT_WEBSITES,
      title: 'Websites',
      requiredRoles: [ROLE_ADMIN],
    },
    {
      id: SUB_WEBSITE_SERVICES,
      cat: CAT_WEBSITE_SERVICES,
      title: 'Services',
      requiredRoles: [ROLE_ADMIN],
    },
    {
      id: SUB_STATUSES,
      cat: CAT_STATUSES,
      title: 'Statuses',
      requiredRoles: [ROLE_ADMIN],
    },
    {
      id: SUB_CUSTOMERS,
      cat: CAT_CUSTOMERS,
      title: 'Customers',
      requiredRoles: [ROLE_LOGISTIC_MANGER, ROLE_LOGISTIC_MANGER_READ],
    },
  ],
};

// Core accounts are reachable from two sections; the editor must stay in the one the
// user came from, so its path is derived from the active route tab.
export const getCoreAccountsPath = (tab) =>
  tab === CMS_TAB_REF_DATA ? `${CMS_TAB_REF_DATA}/${SUB_CORE_ACCOUNTS}` : 'social-media-scraper/accounts';

export const matchesTabRoles = (tab, hasRole) => {
  if (tab.requiredRoles && !tab.requiredRoles.some((role) => hasRole(role))) {
    return false;
  }
  return !tab.categoryRole || hasRole(tab.categoryRole);
};

export const subCatsMap = new Map(
  Object.entries(CMS_SUB_TABS).reduce((acc, [tab, subTabs]) => {
    for (const sub of subTabs) {
      acc.push([sub.cat, { tab, sub: sub.id }]);
    }
    return acc;
  }, [])
);
